






























import { Component, Vue } from 'vue-property-decorator';
import { ZKStatusResponse } from '@service/solr/admin/zookeeper';

@Component
export default class ZookeeperStatus extends Vue {
  private response: ZKStatusResponse = {
    responseHeader: {
      status: 0,
      QTime: 0,
    },
    zkStatus: { details: [], ensembleSize: 0, mode: '', status: '', zkHost: '' },
  };

  private defaultFields = [
    { key: 'host' },
    { key: 'ok', width: 100 },
    { key: 'clientPort', width: 100 },
    { key: 'zk_version' },
    { key: 'zk_znode_count' },
    { key: 'zk_approximate_data_size' },
  ];

  get allFields(): string[] {
    return this.response.zkStatus.details.flatMap((it) => Object.keys(it));
  }

  private refresh() {
    this.$service.solr.admin.zookeeper
      .status()
      .then((res) => (this.response = res.data))
      .catch(this.$notify.error);
  }

  created() {
    this.refresh();
  }
}
